export default __webpack_public_path__ + "static/media/trash_light_icon.3151ecbc.svg";